export const LogoMark = ({ className = "h-14 w-14 md:h-16 md:w-16" }) => (
  <img src="/logo.webp" alt="Insane Circle logo" className={`shrink-0 object-contain ${className}`} />
);

export const Logo = () => (
  <span className="flex items-center gap-2.5">
    <LogoMark />
    <span className="hidden font-display text-lg sm:inline font-extrabold uppercase leading-none tracking-tight">
      Insane<span className="text-lime">Circle</span>
    </span>
  </span>
);
